import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatStepper,
  MatStep,
  MatStepLabel,
  MatStepperNext,
  MatStepperPrevious
} from '@angular/material/stepper';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  standalone: true,
  imports: [
    MatStepper,
    MatStep,
    FlexModule,
    MatStepLabel,
    MatButton,
    MatStepperNext,
    MatStepperPrevious
  ]
})
export class WelcomeComponent {
  constructor() {}
}
